import React, { useState } from 'react';
import styles from './TokenSearchGuidelines.module.sass'

const SearchGuide = () => {
  const [activeTab, setActiveTab] = useState('basic');
  
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Search Query Guide</h2>
      
      <div className={styles.tabButtons}>
        <button 
          className={`${styles.tabButton} ${activeTab === 'basic' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('basic')}
        >
          Basic Searches
        </button>
        <button 
          className={`${styles.tabButton} ${activeTab === 'comparison' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('comparison')}
        >
          Comparisons
        </button>
        <button 
          className={`${styles.tabButton} ${activeTab === 'special' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('special')}
        >
          Special Queries
        </button>
      </div>
      
      {activeTab === 'basic' && (
        <div>
          <p className={styles.description}>Find tokens by name, symbol or simple criteria:</p>
          
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Text Search</h3>
            <div className={styles.example}>ethereum</div>
            <div className={styles.example}>"ETH"</div>
            <div className={styles.example}>not stable</div>
          </div>
          
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Price Search</h3>
            <div className={styles.example}>price above 100</div>
            <div className={styles.example}>price below 10</div>
            <div className={styles.example}>price between 50 and 500</div>
          </div>
        </div>
      )}
      
      {activeTab === 'comparison' && (
        <div>
          <p className={styles.description}>Filter tokens based on various metrics:</p>
          
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Returns</h3>
            <div className={styles.example}>returns above 5%</div>
            <div className={styles.example}>24h returns below -10%</div>
            <div className={styles.example}>7d returns around 20%</div>
          </div>
          
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Market Cap</h3>
            <div className={styles.example}>market cap &gt; 100M</div>
            <div className={styles.example}>cap &lt; 10B</div>
            <div className={styles.example}>cap between 50M and 1B</div>
          </div>
          
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Supported Units</h3>
            <ul className={styles.unitsList}>
              <li>k - thousands (1k = 1,000)</li>
              <li>m - millions (1M = 1,000,000)</li>
              <li>b - billions (1B = 1,000,000,000)</li>
              <li>t - trillions</li>
            </ul>
          </div>
        </div>
      )}
      
      {activeTab === 'special' && (
        <div>
          <p className={styles.description}>Special search queries for quick insights:</p>
          
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Performance Ranking</h3>
            <div className={styles.example}>top performers</div>
            <div className={styles.example}>bottom 5 performers</div>
            <div className={styles.example}>top weekly performers</div>
            <div className={styles.example}>worst performer</div>
          </div>
          
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Market Cap Ranking</h3>
            <div className={styles.example}>highest market cap</div>
            <div className={styles.example}>lowest 3 market cap</div>
          </div>
          
          <div className={styles.proTip}>
            <h3 className={styles.proTipTitle}>Pro Tip</h3>
            <p className={styles.proTipText}>You can combine multiple filters by adding them one after another.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchGuide;